(() => {
  const tabData = {
    "Gut Health": {
      image: "",
      benefits: [
        "Supports gut-lining wellness with turkey tail + boswellia",
        "Helps fill common nutrient gaps with B12, zinc, and magnesium",
        "Supports digestive comfort after meals",
        "Supports regularity and microbiome resilience",
      ],
    },
    "Thyroid Nutrition": {
      image: "",
      benefits: [
        "Supports T4 to T3 conversion with selenium, zinc, and B vitamins",
        "Helps support nutrients involved in thyroid function",
        "Supports steadier daily energy and metabolic rhythm",
        "Built for thyroid-conscious daily routines",
      ],
    },
    "Whole-Body Reset": {
      image: "",
      benefits: [
        "Pairs gut lining support with thyroid-focused nutrition",
        "Creates one simple morning routine instead of a scattered stack",
        "Supports immune, digestive, and energy pathways together",
        "Best starting point for a more organized daily routine",
      ],
    },
  };

  function initAxosHomepage(root) {
    if (!root || root.dataset.axosJsReady === "true") return;
    root.dataset.axosJsReady = "true";

    const menu = root.querySelector("[data-axos-menu]");
    const menuButton = root.querySelector('button[aria-label="Open menu"]');
    const closeButtons = root.querySelectorAll("[data-axos-menu-close]");
    if (menu && menuButton) {
      if (menu.parentElement !== document.body) {
        document.body.appendChild(menu);
      }
      menuButton.setAttribute("aria-controls", menu.id || "axos-home-menu");
      const openMenu = () => {
        menu.hidden = false;
        menuButton.setAttribute("aria-expanded", "true");
        document.documentElement.classList.add("axos-menu-open");
        document.body.classList.add("axos-menu-open");
      };
      const closeMenu = () => {
        menu.hidden = true;
        menuButton.setAttribute("aria-expanded", "false");
        document.documentElement.classList.remove("axos-menu-open");
        document.body.classList.remove("axos-menu-open");
      };
      menuButton.addEventListener("click", openMenu);
      closeButtons.forEach((button) =>
        button.addEventListener("click", closeMenu),
      );
      menu
        .querySelectorAll("a")
        .forEach((link) => link.addEventListener("click", closeMenu));
      root.addEventListener("keydown", (event) => {
        if (event.key === "Escape") closeMenu();
      });
    }

    const tabs = root.querySelectorAll("[data-axos-home-tab]");
    const tabImage = root.querySelector("[data-axos-home-tab-image]");
    const tabTitle = root.querySelector("[data-axos-home-tab-title]");
    const tabBenefits = root.querySelectorAll("[data-axos-home-tab-benefit]");
    const tabCta = root.querySelector("[data-axos-home-tab-cta]");
    const productTabImages = {
      "Gut Health": root.dataset.axosGutImage,
      "Thyroid Nutrition": root.dataset.axosThyroidImage,
      "Whole-Body Reset": root.dataset.axosSystemImage,
    };
    const productTabLinks = {
      "Gut Health": {
        href: root.dataset.axosGutUrl || "/products/ibdassist",
        label: "Shop GUTsupport",
      },
      "Thyroid Nutrition": {
        href: root.dataset.axosThyroidUrl || "/products/hashiaid",
        label: "Shop HashiAid",
      },
      "Whole-Body Reset": {
        href: root.dataset.axosSystemUrl || "/products/axos-system",
        label: "Shop the Axos System",
      },
    };
    const setTab = (name) => {
      const data = tabData[name];
      if (!data) return;
      tabs.forEach((tab) => {
        const active = tab.dataset.axosHomeTab === name;
        tab.className = active
          ? "px-5 py-2.5 rounded-full text-sm font-semibold border-2 transition-all axos-gradient text-white border-transparent"
          : "px-5 py-2.5 rounded-full text-sm font-semibold border-2 transition-all bg-white border-black/10 text-[#000019]/70 hover:border-[#5094F4]/40";
        tab.setAttribute("aria-selected", active ? "true" : "false");
      });
      if (tabImage) {
        tabImage.src = productTabImages[name] || data.image;
        tabImage.alt = name;
      }
      if (tabTitle) tabTitle.textContent = name;
      tabBenefits.forEach((item, index) => {
        item.textContent = data.benefits[index] || "";
      });
      if (tabCta && productTabLinks[name]) {
        tabCta.href = productTabLinks[name].href;
        const label = tabCta.querySelector("[data-axos-home-tab-cta-label]");
        if (label) label.textContent = productTabLinks[name].label;
      }
    };
    tabs.forEach((tab) =>
      tab.addEventListener("click", () => setTab(tab.dataset.axosHomeTab)),
    );
    if (tabs.length) setTab(tabs[0].dataset.axosHomeTab);

    root.querySelectorAll('#faq [role="region"]').forEach((panel) => {
      panel.hidden = true;
      panel.setAttribute("data-state", "closed");
    });
    root.querySelectorAll("#faq button[aria-controls]").forEach((button) => {
      const panel = root.querySelector(
        "#" + CSS.escape(button.getAttribute("aria-controls")),
      );
      const item = button.closest("[data-state]");
      if (!panel) return;
      button.addEventListener("click", () => {
        const open = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", open ? "false" : "true");
        button.setAttribute("data-state", open ? "closed" : "open");
        if (item) item.setAttribute("data-state", open ? "closed" : "open");
        panel.hidden = open;
        panel.setAttribute("data-state", open ? "closed" : "open");
      });
    });

    const buySection = root.querySelector("#axos-buy");
    let offers = Array.from(root.querySelectorAll("[data-axos-offer]"));
    if (!offers.length && buySection) {
      offers = Array.from(buySection.querySelectorAll("button")).filter((button) =>
        /subscribe|one-time/i.test(button.textContent || ""),
      );
      offers.forEach((offer) => {
        const isSubscribe = /subscribe/i.test(offer.textContent || "");
        offer.dataset.axosOffer = isSubscribe ? "subscribe" : "onetime";
      });
    }
    const cart = root.querySelector("[data-axos-home-cart]");
    const variantId = root.dataset.axosSystemVariantId;
    const sellingPlanId = root.dataset.axosSystemSellingPlanId;
    const hashiaidVariantId = root.dataset.axosHashiaidVariantId;
    const gutsupportVariantId = root.dataset.axosGutsupportVariantId;
    const oneTimePrice = root.dataset.axosSystemPrice;
    const subscribePrice = root.dataset.axosSystemSubscribePrice;
    const buildCartUrl = (type) => {
      if (!variantId) return cart ? cart.href : "/cart";
      if (
        type === "subscribe" &&
        sellingPlanId &&
        hashiaidVariantId &&
        gutsupportVariantId
      ) {
        const subscriptionParams = new URLSearchParams({
          selling_plan: sellingPlanId,
        });
        return `/cart/${hashiaidVariantId}:1,${gutsupportVariantId}:1?${subscriptionParams.toString()}`;
      }
      return `/cart/${variantId}:1`;
    };
    const addSubscriptionComponents = async () => {
      if (!sellingPlanId || !hashiaidVariantId || !gutsupportVariantId) {
        return false;
      }
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(hashiaidVariantId),
              quantity: 1,
              selling_plan: Number(sellingPlanId),
            },
            {
              id: Number(gutsupportVariantId),
              quantity: 1,
              selling_plan: Number(sellingPlanId),
            },
          ],
        }),
      });
      if (!response.ok) {
        throw new Error("Subscription add failed");
      }
      return true;
    };
    const addOneTimeSystem = async () => {
      if (!variantId) return false;
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
            },
          ],
        }),
      });
      if (!response.ok) {
        throw new Error("One-time add failed");
      }
      return true;
    };
    const offerLabel = (type) =>
      type === "subscribe"
        ? `Add to Cart - ${subscribePrice || ""}`.trim()
        : `Add to Cart - ${oneTimePrice || ""}`.trim();
    const setOffer = (offer) => {
      const selectedType = offer.dataset.axosOffer || "subscribe";
      offers.forEach((item) => {
        const active = item === offer;
        item.classList.toggle("border-[#5094F4]", active);
        item.classList.toggle("bg-[#EAF6FE]", active);
        item.classList.toggle("border-black/10", !active);
        item.classList.toggle("bg-white", !active);
        item.setAttribute("aria-pressed", active ? "true" : "false");
        const radio = item.querySelector(".w-5.h-5");
        if (!radio) return;
        radio.classList.toggle("border-[#5094F4]", active);
        radio.classList.toggle("border-black/25", !active);
        radio.innerHTML = active
          ? '<span class="w-2.5 h-2.5 rounded-full bg-[#5094F4]"></span>'
          : "";
      });
      if (cart) {
        cart.textContent = offer.dataset.label || offerLabel(selectedType);
        cart.href = offer.dataset.url || buildCartUrl(selectedType);
        cart.dataset.axosSelectedOffer = selectedType;
      }
    };
    offers.forEach((offer) => {
      offer.type = "button";
      offer.addEventListener("click", () => setOffer(offer));
    });
    if (offers.length) {
      setOffer(
        offers.find((offer) => offer.dataset.axosOffer === "subscribe") ||
          offers[0],
      );
    }
    if (cart) {
      cart.addEventListener("click", async (event) => {
        const selectedOffer = cart.dataset.axosSelectedOffer || "subscribe";
        if (selectedOffer !== "subscribe" && selectedOffer !== "onetime") return;
        if (selectedOffer === "subscribe" && (!sellingPlanId || !hashiaidVariantId || !gutsupportVariantId)) return;
        if (selectedOffer === "onetime" && !variantId) return;
        event.preventDefault();
        const originalText = cart.textContent;
        cart.textContent = "Adding...";
        cart.setAttribute("aria-busy", "true");
        try {
          if (selectedOffer === "subscribe") {
            await addSubscriptionComponents();
          } else {
            await addOneTimeSystem();
          }
          window.location.href = "/checkout";
        } catch (error) {
          console.error(error);
          cart.textContent = originalText || offerLabel(selectedOffer);
          cart.removeAttribute("aria-busy");
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll(".axos-homepage-port").forEach(initAxosHomepage);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();

